import { InputNumber, Button, Table, Space, message, Form, Image, Spin, Select } from 'antd';
import constants from '../../constants/constants';
import React from "react";
import { useEffect } from 'react';
import APIUtils from '../../api/APIUtils';
import Cookies from 'js-cookie';
import WebLinks from '../../api/WebLinks';
import { useState } from 'react';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, GetPriorityLevelIcons } from '../../globalFunctions/GlobalFunctions';
import { useContext } from 'react';
import { CommonContext, CurrencyContext } from '../../Context';

const Budgets = (props) => {
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
	const currencyContext=useContext(CurrencyContext);
	const [Loading,setLoading]=useState(false);
	const [supplierList,setSupplierList]=useState([]);
	const [data,setData]=useState([]);
	const [total,setTotal]=useState(100);
	const [currentPage,setCurrentPage]=useState(1);
	const [supplierID,setSupplierID]=useState(null);
	const [pageSize,setPageSize]=useState(100);
	const [priorityCheck,setPriorityCheck]=useState("f");
	const [form] = Form.useForm();
	
	const budgetValColumns = [
		{
			title: <span className='uppercase font-bold'>This month</span>,
			align: "left",
			children:[
				{
					title:<span className='font-bold'>Budget</span>,
					key: 'thisMonth',
					dataIndex: 'thisMonth',
					width: '12.5%',
					render: (text, record, index) => (
						<>
							{index===0 || !record.overallBudget ? (
								<span className='font-extrabold'>{currencyContext.currency}{text}</span>) :
								(
									// initialValue={text}
									<Form.Item name={'thisMonth'+index} rules={[
										{
										  required: true,
										  message: "Required field",
										},
									  ]}>
										<InputNumber size="large" className='w-44' addonAfter={<Button className='warning-btn uppercase font-bold' onClick={(e)=>updateBudget('thisMonth', index, record)}>{constants.UpdateBtn}</Button>} />
									</Form.Item>
								)}
						</>
					),
				},
				{
					title:<span>(spend)</span>,
					key: 'thisMonthSpend',
					dataIndex: 'thisMonthSpend',
					width: '12.5%',
					render: (_,item) => (
						<Space size="small">
							<span>({currencyContext.currency}{item.thisMonthSpend})</span>
							{item.thisMonth>0?<span className={item.thisMonthSpend>0?'text-green-500 font-bold':'text-red-500 font-bold'}>{item.thisMonthSpentPer+"%" }</span>:null}
						</Space>
					),
				}
			]
		},
	];
	const NotDeliveringCol = [
		{
			dataIndex: 'Buyer Name',
			key: 'buyerName',
			width: '40%',
			render: (text, record, index) => <>
				<span className='uppercase font-bold text-gray-400'>{record.buyerName}</span>
			</>
		},
		{
			dataIndex: 'supplierName',
			key: 'supplierName',
			width: '35%',
			render: (text, record, index) => <>
				{record.logoURL && record.logoURL!==""? <Image src={record.logoURL} preview={false} width={100}/> :<span className='uppercase font-bold text-gray-400'>{record.supplierName}</span>}
			</>
		},
		...budgetValColumns
		
	];
	const BudgetCol =[
		{
			dataIndex: 'Buyer Name',
			key: 'buyerName',
			width: '15%',
			render: (text, record, index) => <>
				{index === 0 ? (<span className='uppercase font-extrabold text-lg'>Total Budget</span>) : <span className='uppercase font-bold text-gray-400'>{record.buyerName}</span>}
			</>
		},
		{
			dataIndex: 'budgetCategory',
			key: 'budgetCategory',
			width: '5%',
			render: (text, record, index) => <span className='font-bold text-gray-400'>
				{index===0?"":record.overallBudget ? '(Overall)' : '(By Priority)'}
			</span>,
		},
		{
			title: <span className='uppercase font-bold'>Last month</span>,
			align: "left",
			children:[
				{
					title:<span className='font-bold'>Budget</span>,
					dataIndex: 'lastMonth',
					key: 'lastMonth',
					render: (text) => <span className='font-extrabold'>{currencyContext.currency}{text}</span>
				},
				{
					title: <span>(spend)</span>,
					dataIndex:'lastMonthSpend',
					key:'lastMonthSpend',
					render:(_,item) =>
					<Space size="small">
						<span>({currencyContext.currency}{item.lastMonthSpend})</span>
						{item.lastMonth>0?<span className={item.lastMonthSpend>0?'text-green-500 font-bold':'text-red-500 font-bold'}>{item.lastMonthSpentPer+"%"}</span>:null}
					</Space>
				}
			]
		},
		...budgetValColumns,
		{
			title: <>
				<span className='uppercase font-bold'>Next month</span>
				<br/>
				<span className='font-bold'>Budget</span>
			</>,
			key: 'nextMonth',
			dataIndex: 'nextMonth',
			width: '25%',
			render: (text, record, index) => (
				<>
				{index===0 || !record.overallBudget ? (
								<span className='font-extrabold'>{currencyContext.currency}{text}</span>) :
					(<div>
						<Form.Item name={'nextMonth'+index} initialValue={text} rules={[
						{
							required: true,
							message: "Required field",
						},
						]}>
							<InputNumber name={'nextMonth'+index} defaultValue={text} size="large" className='w-44' addonAfter={<Button className='warning-btn uppercase font-bold' onClick={(e)=>updateBudget("nextMonth", index, record)}>{constants.UpdateBtn}</Button>} />
						</Form.Item>
					</div>)}
				</>
			),
		},
	];
	const columns = props.tabName===constants.MultiBudgetsAdminTab1?[...BudgetCol]:[...NotDeliveringCol]
	// Priority expandable sub table.
	const expandedRowRender = (record,index, indent, expanded) => {
		const byPriorityColumns = [
			{
				dataIndex: 'Buyers',
				key: 'suppliers',
				width: '15.6%',
				render: (text) => <span className='uppercase font-bold invisible'>{text} Budget</span>,
			},
			{
				dataIndex: 'priorityLevel',
				key: 'priorityLevel',
				width: '12%',
				render: (text) => <Space>
					{/* {GetPriorityLevelIcons(text)} */}
					<div className={priorityCheck==="t"?GetCustomPriorityLevelIcons(text):GetPriorityLevelColors(text)}></div>
					<span>{text}</span>
				</Space>,
			},
			{
				title: <span className='uppercase font-bold'>Last month</span>,
				align: "left",
				children:[
					{
						title:<span className='font-bold'>Budget</span>,
						dataIndex: 'lastMonth',
						key: 'lastMonth',
						width: '8.5%',
						render: (text) => <span className='font-extrabold'>{currencyContext.currency}{text}</span>
					},
					{
						title: <span>(spend)</span>,
						dataIndex:'lastMonthSpend',
						key:'lastMonthSpend',
						width: '13%',
						render:(_,item) =>
						<Space size="small">
							<span>({currencyContext.currency}{item.lastMonthSpend})</span>
							{item.lastMonth>0?<span className={item.lastMonthSpend>0?'text-green-500 font-bold':'text-red-500 font-bold'}>{item.lastMonthSpentPer}%</span>:null}
						</Space>
					}
				]
			},
			{
				title: <span className='uppercase font-bold'>This month</span>,
				align: "left",
				children:[
					{
						title:<span className='font-bold'>Budget</span>,
						key: 'thisMonth',
						dataIndex: 'thisMonth',
						width: '13%',
						render: (text, record, index) => (
							<Form.Item name={'thisMonth-priority'+index} initialValue={text} rules={[
								{
								  required: true,
								  message: "Required field",
								},
							  ]}>	
								<InputNumber size="large" className='w-44' addonAfter={<Button className='warning-btn uppercase font-bold' onClick={(e)=>updateBudget('thisMonth', index, record, true)}>{constants.UpdateBtn}</Button>} />
							</Form.Item>
							
						),
					},
					{
						title:<span>(spend)</span>,
						key: 'thisMonthSpend',
						dataIndex: 'thisMonthSpend',
						width: '13%',
						render:  (_,item) => (
							<Space size="small">
								<span>({currencyContext.currency}{item.thisMonthSpend})</span>
								{item.thisMonth>0?<span className={item.thisMonthSpend>0?'text-green-500 font-bold':'text-red-500 font-bold'}>{item.thisMonthSpentPer}%</span>:null}
							</Space>
						),
					}
				]
			},
			{
				title: <span className='uppercase font-bold'>Next month</span>,
				key: 'nextMonth',
				width: '26%',
				render: (text, record, index) => (
					<Form.Item name={'nextMonth-priority'+index} initialValue={text} rules={[
						{
						  required: true,
						  message: "Required field",
						},
					  ]}>	
						<InputNumber size="large" className='w-44' addonAfter={<Button className='warning-btn uppercase font-bold' onClick={(e)=>updateBudget('nextMonth', index, record, true)}>{constants.UpdateBtn}</Button>} />
					</Form.Item>
					
				),
			},
		];
		const byPriorityData = record.priorityList;
		return <Table columns={byPriorityColumns} dataSource={byPriorityData} size="middle" showHeader={false} pagination={false} />;
	};
	const getSupplierList = async () =>{
		let suppliers=[];
		const response = await APIUtils.apiCall('GET',WebLinks.GetSubBuyerSuppliers);
		if(!response.isCatch && response.resultObj.statusCode==="2000"){
			response.resultObj?.data?.map((item,index)=>{
				item.value=item.supplierId;
				item.label=item.supplierName;
			})
			suppliers=response?.resultObj?.data;
			setSupplierList(suppliers);
		}else{
			setSupplierList([]);
			message.error(response.resultObj.message || "No Suppliers");
    	}
		return suppliers;
	};
	const getData = async(currentpage=1, supplierId = supplierID , pageSizevalue=pageSize) =>{
		setLoading(true);
		if(!supplierId && props.tabName===constants.MultiBudgetsAdminTab1){
			let suppliers = supplierList;
			if(!supplierList.length>0){
				suppliers = await getSupplierList();
			}
			supplierId = suppliers.length>0? suppliers[0]?.supplierId : '';
		}
		
		let url;
		switch (props.tabName) {
			case constants.MultiBudgetsAdminTab1: url= WebLinks.SubBuyerBudget+buyerId+"&supplierId="+supplierId+"&limit="+pageSizevalue+"&pageNo="+currentpage;
				break;
			case constants.MultiBudgetsAdminTab2: url= WebLinks.SubBuyerNotDelivering+buyerId+"&limit="+pageSizevalue+"&pageNo="+currentpage;
				break;
			case constants.MultiBudgetsAdminTab3:url= WebLinks.SubBuyerOverBudget+buyerId+"&limit="+pageSizevalue+"&pageNo="+currentpage;
				break;
		
			default: url = WebLinks.SubBuyerBudget+buyerId+"&supplierId="+supplierId+"&limit="+pageSizevalue+"&pageNo="+currentpage;
				break;
		}
		const todayDate =new Date();
		const response = await APIUtils.apiCall('GET',url);
    	if(!response.isCatch && response.resultObj.statusCode==="2000"){
			//Start: Added unique key to fix all inner tables opening together
			response.resultObj.data.map((item,index)=>{
				item.key=index;
			})
			//end
			setData(response.resultObj.data);
			setTotal(response.resultObj.getCount);
    	}else{
			setData([]);
			message.error(response?.resultObj?.message);
    	}
		setLoading(false);
	};
	const onchangeBudgetTable = (pagination, filters, sorter) =>{
		if(pagination){
			setCurrentPage(pagination);
			setPageSize(filters);
			getData(pagination,supplierID,filters);
		}
	};
	const updateBudget= async (col,index, record, sub=false)=>{
		setLoading(true);
		let fieldName=sub?col+'-priority'+index:col+index;
		let Budget = form.getFieldValue(fieldName);
		const todayDate =new Date();
		let month = col==="nextMonth"?todayDate.getMonth()+2:todayDate.getMonth()+1;
		let year = todayDate.getFullYear();
		if (col === "nextMonth" && month > 12) {
			month = 1;
			year++;
		}
		const payload ={
			// id: 0,
			buyerId: record.buyerId,
			supplierId: record.supplierId,
			month: month,
			year: year,
			priorityLevel: record.overallBudget? 10 : record.priorityLevel,
			budget: Budget,
			UpdatedByBuyerId:Cookies.get(constants.COOKIE_LOGGED_BUYER_ID)
		  }
		const response = await APIUtils.apiCall('POST',WebLinks.UpdateBudget,JSON.stringify(payload));
    	if(!response.isCatch && response.resultObj.statusCode==="2000"){
			getData(currentPage,record.supplierId,pageSize);
			message.success(response.resultObj.message);
    	}else{
			message.error(response.resultObj.message);
    	}
		setLoading(false);
	};
  //Function to get priority list
  const getBuyerPrioritylist=async()=>{
    let url = WebLinks.GetBuyerPriorityFilters + buyerId;    
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      setPriorityCheck(response?.resultObj?.data?.length>5?"t":"f");
    } else {
      message.error(response?.resultObj?.message);
    }
  };
	useEffect(()=>{
		getBuyerPrioritylist();
		getData();
	},[])
	useEffect(() => {
		// Update the form with new initial values when the data changes
		const initialValues = data.reduce((acc, item,index) => {
			if(index>0){				
				acc[`thisMonth${index}`] = item.thisMonth;
				acc[`nextMonth${index}`] = item.nextMonth;
				
			}
			return acc;
		}, {});
		form.setFieldsValue(initialValues);
	  }, [data, form]);
	
	return (
		<div>
			<div className='flex flex-wrap justify-between items-center gap-1'>
			{/* <div className="flex flex-wrap justify-between items-center gap-1 mb-3"> */}
				
					<Space wrap>
					{supplierList.length>0?(
						<>
						<span>Suppliers: </span>
						<Space.Compact>
							
								<Select
								placeholder="Suppliers"
								className="w-[65vw] md:w-60"
								onChange={(e)=>{setSupplierID(e); setCurrentPage(1);setPageSize(100); getData(1,e,100)}}
								defaultValue={supplierList[0]?.supplierId}
								options={supplierList}
								/>
						</Space.Compact>
						</>
				):<div/>}
					</Space>
				<span className='text-gray-400'>{constants.BudgetsMsg}</span>
			</div>
			<Spin spinning={Loading}>
				<div className='mt-3 overflow-x-auto'>
					<Form form={form}>
						<Table
							className='budgets-table'
							size="middle"
							columns={columns}
							dataSource={data}
							scroll={{ x: 965, /* y: 450 */ }}
							expandable={{
								// defaultExpandedRowKeys: ['3', '4'],
								expandedRowRender,
								rowExpandable: (record) => false,//record.suppliers !== 'Indeed' && record.suppliers !== 'Total' && record.suppliers !== 'Social Media',
							}}
							pagination={{
								total:total,
								onChange:onchangeBudgetTable,
								defaultPageSize:100
								// pageSize:props.tabName===constants.MultiBudgetsAdminTab1? constants.BudgetpageSize + 1 : constants.pageSize
							}}
						/>
					</Form>
				</div>
			</Spin>
		</div>
	);
};

export default Budgets;
